<template>
  <div class="alert-viewer fixed bottom-0 z-20 mb-2 w-full">
    <MultiAlert
      v-if="currentAlert"
      :type="currentAlert.type"
      class="mx-1 md:mx-2"
      size="large"
      closable
      @close="onAlertClose"
    >
      <template #title v-if="currentAlert.title">
        {{ currentAlert.title }}
      </template>
      <template #default v-if="currentAlert.body">
        {{ currentAlert.body }}
      </template>
      <template v-if="currentAlert.action" #action="{ buttonColor }">
        <GeneralButton v-if="currentAlert.action" :color="buttonColor" @click="onAlertAction">
          {{ currentAlert.action.label }}
        </GeneralButton>
      </template>
    </MultiAlert>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"
import { useAlertStore } from "@/store/alert.store"
import MultiAlert from "@/components/alerts/MultiAlert.vue"
import GeneralButton from "@/components/inputs/GeneralButton.vue"

const alertStore = useAlertStore()
const { currentAlert } = storeToRefs(alertStore)

function onAlertClose() {
  alertStore.displayNextAlert()
}

async function onAlertAction() {
  const action = currentAlert.value?.action
  if (!action) return

  await action.handler()
  onAlertClose()
}
</script>

<style scoped></style>
